import { Error } from '../components/Error'
import React from 'react'
import { useFormik } from 'formik'
import { object, string, ref } from 'yup'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { auth } from '../firebase-config'
import {
  updatePassword,
  EmailAuthProvider,
  reauthenticateWithCredential,
} from 'firebase/auth'
import { Button } from '../components/Button'
import { Input } from '../components/Input'

const requiredMsg = 'Dieses Feld ist verpflichtend'

const validatePassword = object({
  passwordOld: string().min(7, 'mindestens 7 Zeichen').required(requiredMsg),
  passwordNew: string().min(7, 'mindestens 7 Zeichen').required(requiredMsg),
  passwordConfirmation: string()
    .oneOf([ref('passwordNew'), null], 'Passwort stimmt nicht überein!')
    .required(requiredMsg),
})

const initialValues = {
  passwordOld: '',
  passwordNew: '',
  passwordConfirmation: '',
}

export const EditPassword = () => {

  const user = auth.currentUser

  const formik = useFormik({
    initialValues,
    validationSchema: validatePassword,
    onSubmit: (values) => {
      handleSubmit(values)
    },
  })

  async function handleSubmit(values) {
    const credential = EmailAuthProvider.credential(
      user.email,
      values.passwordOld,
    )
    reauthenticateWithCredential(user, credential)
      .then(() => {
        return updatePassword(user, values.passwordNew)
      })
      .then(() => {
        formik.resetForm()
        toast.success('Dein Passwort wurde erfolgreich aktualisiert.', {
          position: 'top-center',
        })
      })
      .catch(() => {
        toast.error(
          'Es hat leider nicht funktioniert. Versuche es nochmal und kontrolliere deine Eingaben.',
          {
            position: 'top-center',
          },
        )
      })
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <div>
        <Input
          name='passwordOld'
          type='password'
          label='Altes Passwort'
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.passwordOld}
        />
        {formik.touched.passwordOld && formik.errors.passwordOld && (
          <Error msg={formik.errors.passwordOld} />
        )}
      </div>
      <div>
        <Input
          name='passwordNew'
          type='password'
          label='Neues Passwort'
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.passwordNew}
        />
        {formik.touched.passwordNew && formik.errors.passwordNew && (
          <Error msg={formik.errors.passwordNew} />
        )}
      </div>
      <div>
        <Input
          name='passwordConfirmation'
          type='password'
          label='Neues Passwort wiederholen'
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.passwordConfirmation}
        />
        {formik.touched.passwordConfirmation &&
          formik.errors.passwordConfirmation && (
            <Error msg={formik.errors.passwordConfirmation} />
          )}
      </div>

      <Button type='submit'>bestätigen und speichern</Button>
    </form>
  )
}
